// Date utilities — supports frozenDate for demo orgs
// When frozenDate is set, getCurrentDate() returns it instead of real time,
// so all "today"/"last 24h" queries anchor to the seed date.

let _frozenDate = null;

/**
 * Set the frozen date (called from AuthContext when org has frozenDate)
 */
export function setFrozenDate(isoString) {
  if (isoString) {
    _frozenDate = new Date(isoString);

  } else {
    _frozenDate = null;
  }
}

/**
 * Clear frozen date (called on logout or org switch)
 */
export function clearTimezoneCache() {
  _frozenDate = null;
}

/**
 * Get the current date — returns frozenDate if set, otherwise real time
 */
export async function getCurrentDate() {
  return _frozenDate ? new Date(_frozenDate.getTime()) : new Date();
}

/**
 * Clear all caches
 */
export function clearAllCaches() {
  _frozenDate = null;
}
